export const getCustomerPermission = (): string | null => {
    const permissionToShow = localStorage.getItem("user-token");
  
    if (!permissionToShow) return null;
  
    try {
      const parsedPermission = JSON.parse(permissionToShow);
      const ticketPermission = parsedPermission?.teams?.[0]?.module_permissions?.access?.customers;
      return ticketPermission || null;
    } catch (error) {
      console.error("Error parsing user-token:", error);
      return null;
    }
  };